import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTenantId } from '@/stores/tenant.store';
import { bookingKeys, jobKeys, schedulerKeys } from '@/lib/queryKeys';

const channelName = (tenantId: string) => `notifi:dispatch:${tenantId}`;

/** Only an invalidation signal crosses windows; no customer data is broadcast. */
export function notifyDispatchUpdate(tenantId: string | null | undefined) {
  if (!tenantId || typeof BroadcastChannel === 'undefined') return;
  const channel = new BroadcastChannel(channelName(tenantId));
  channel.postMessage('refresh');
  channel.close();
}

export function useDispatchQueueSync() {
  const tenantId = useTenantId();
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!tenantId || typeof BroadcastChannel === 'undefined') return;
    const channel = new BroadcastChannel(channelName(tenantId));
    channel.onmessage = (event) => {
      if (event.data !== 'refresh') return;
      void queryClient.invalidateQueries({ queryKey: schedulerKeys.all() });
      void queryClient.invalidateQueries({ queryKey: bookingKeys.all() });
      void queryClient.invalidateQueries({ queryKey: jobKeys.all() });
    };
    return () => channel.close();
  }, [tenantId, queryClient]);
}
